import { useMutation } from '@tanstack/react-query'

import { authAPI } from '@/api/new-api'

// Note: the delete endpoint is keyed by the client's user id (clientData.user.id), not the
// client id used elsewhere on this page (e.g. useUpdateClientActiveStatus's clientId) - matches
// the pre-refactor delete flow in ClientProfileView.jsx's handleDelete.
const deleteClient = async (userId: number) => {
  const response = await authAPI.delete(`/client/${userId}`)
  return response.data
}

export const useDeleteClient = () =>
  useMutation({
    mutationFn: (userId: number) => deleteClient(userId),
  })
